/* tslint:disable:no-trailing-whitespace import-spacing */

import {
  Routes,
  RouterModule
}                                    from '@angular/router';

import { NgModule                  } from '@angular/core';

import { IDEComponent              } from './screens/ide/ide.component';
import { LoginComponent            } from './screens/login/login.component';
import { RegisterComponent         } from './screens/register/register.component';
import { UserListPageComponent     } from './screens/administration/user.list.page.component';
import { ProfilePageComponent      } from './screens/profile/profile.page.component';
import { AdminPageComponent        } from './screens/administration/admin.page.component';
import { UserDetailPageComponent   } from './screens/administration/user.detail.page.component';
import { PendingUsersPageComponent } from './screens/administration/pending.users.page.component';
import { ApproveUserPageComponent  } from './screens/administration/approve.user.page.component';
import { NewUserPageComponent      } from './screens/administration/new.user.page.component';
import { LoggedInGuard             } from './guards/logged.in.guard';

/* define the URI path to view mapping ... */

const appRoutes: Routes = [

  { path: 'ide',                              component: IDEComponent,              canActivate: [LoggedInGuard]},
  { path: 'profile',                          component: ProfilePageComponent,      canActivate: [LoggedInGuard]},
  { path: 'administration',                   component: AdminPageComponent,        canActivate: [LoggedInGuard]},
  { path: 'administration/users/pending',     component: PendingUsersPageComponent, canActivate: [LoggedInGuard]},
  { path: 'administration/users/approve/:id', component: ApproveUserPageComponent,  canActivate: [LoggedInGuard]},
  { path: 'administration/users/new',         component: NewUserPageComponent,      canActivate: [LoggedInGuard]},
  { path: 'administration/users/detail/:id',  component: UserDetailPageComponent,   canActivate: [LoggedInGuard]},
  { path: 'administration/users',             component: UserListPageComponent,     canActivate: [LoggedInGuard]},
  { path: 'register',                         component: RegisterComponent     },
  { path: 'login',                            component: LoginComponent        },

  /* otherwise, redirect to home */

  { path: '**',             redirectTo: '/ide'               }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        enableTracing: true,
        paramsInheritanceStrategy: 'always'
      }
    )
  ],
  exports: [ RouterModule ]
})

export class AppRouting { }
